export type AsyncJobPhase = 'QUEUED' | 'STARTED' | 'FINISHED' | 'FAILED' | 'TIMEOUT' | 'NOT_SUBMITTED';

/** In-flight (or not-yet-seen) statuses that should keep the batch poller running. */
export function isAsyncJobActive(status: AsyncJobPhase | undefined): boolean {
  return !status || status === 'QUEUED' || status === 'STARTED';
}

/** Settled statuses — polling can stop and UIs can treat the job as done. */
export function isAsyncJobTerminal(status: AsyncJobPhase): boolean {
  return status === 'FINISHED' || status === 'FAILED' || status === 'TIMEOUT' || status === 'NOT_SUBMITTED';
}

/** Terminal outcomes that are not a successful finish. */
export function isAsyncJobFailure(status: AsyncJobPhase): boolean {
  return status === 'FAILED' || status === 'TIMEOUT' || status === 'NOT_SUBMITTED';
}
